import * as React from 'react';
import * as Images from 'pos/Images';
import { Res, CustomerDetailsDTO } from 'core/api';
import { Button, Flex } from 'core/ui';
import { ActionButtonDefinition, InfoCard, PosStatelessScreenClassComponent, ScreenSize } from 'pos/ui';
import { Modal } from 'core/ui-next/modal';

type Props = {
	customer: CustomerDetailsDTO;
	parent: CustomerDetailsDTO;
} & Modal.Actions<CustomerDetailsDTO>

class SelectCustomerDialog extends PosStatelessScreenClassComponent<Props> {

	constructor(props: Props) {
		super(props);
	}

	protected getScreenId(): string {
		return 'SELECT_PARENT_CUSTOMER';
	}

	protected getTitle(): string {
		return Res.Web.SELECT_PARENT_CUSTOMER();
	}

	protected getImage(): string | SvgIcon {
		return Images.Customer;
	}

	protected getSize(): ScreenSize {
		return 'small';
	}

	protected getActionButtonsDefs(): Nullable<ActionButtonDefinition>[] {
		return [
			this.cancelButton(),
			null,
			null,
			null,
			null,
			null
		];
	}

	protected getContent(): React.ReactNode {

		const { customer, parent } = this.props;

		const createCustomerFlexItem = (customer: CustomerDetailsDTO) => {

			const onSelect = () => this.close(customer);
			return <Flex.Item style={{ position: 'relative' }}>
				<div style={{ position: 'absolute', top: 25, right: 10 }}>
					<Button buttonStyle='info' onClick={onSelect}>{Res.Web.SELECT_PARENT_CUSTOMER_SELECT_BTN()}</Button>
				</div>
				<InfoCard Icon='fa fa-id-card-o' title={customer.FiscalName} lines={[customer.BusinessName, customer.Cif, customer.Type.Name]} />
				<InfoCard Icon='fa fa-building-o' title={customer.Address.Street} lines={[`${customer.Address.ZipCode} ${customer.Address.Region}`]} />
			</Flex.Item>;
		};

		return <Flex.Vertical>

			{createCustomerFlexItem(parent)}
			<Flex.Item><hr /></Flex.Item>
			{createCustomerFlexItem(customer)}

		</Flex.Vertical>;
	}

	onComponentDidMount(): void { }
	onComponentWillUnmount(): void { }

	protected override useKeypad(): boolean {
		return false;
	}

	protected override useKeyboard(): boolean {
		return false;
	}

}

export default function selectParentCustomer(customer: CustomerDetailsDTO, parent: CustomerDetailsDTO): Promise<Result<CustomerDetailsDTO>> {
	return Modal.show(SelectCustomerDialog, { customer: customer, parent: parent });
}
